module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/obeP8K/tc-custom/cover.jpeg?1663929383498?1704425338058",
      "alt": "This image is the cover for the book Masters of the Vortex, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Masters of the Vortex, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A churning nuclear fireball, appearing out of nowhere, bringing utter destruction--and countless numbers of them were menacing planets throughout the Galaxy! \"Storm\" Cloud, nucleonic genius, set out in his spaceship Vortex Blaster to track and destroy the mysterious vortices--and embarked on a saga of adventure, discovery and conflict among the far stars that could have been told only by the incomparable \"Doc\" Smith. (Goodreads)")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      E. E. Smith\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Edward Elmer Smith (May 2, 1890 – August 31, 1965), publishing as E. E. Smith, Ph.D. and later as E. E. \"Doc\" Smith, was an American food engineer (specializing in doughnut and pastry mixes) and science-fiction author, best known for the Lensman and Skylark series. He is sometimes called the father of space opera.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    OTB ebook\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0